import React from "react";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import { globalImport } from "../../../common/globalImports";
import { View, Text } from "react-native";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const BottomInfoContest = ({ isClosedContest = false }) => {
  return (
    <View
      style={{
        paddingVertical: 15,
        backgroundColor: Color.bgWhite,
        paddingHorizontal: 5,
        position: globalImport.isWeb
          ? isClosedContest
            ? "fixed"
            : "sticky"
          : "absolute",
        bottom: 0,
      }}
    >
      <FormTextLabel
        labelStyles={{
          ...globalFontStyle.appFontSmallText,
          color: Colors.lightgrey,
        }}

        label={"Leaderboard ranking is based on your trading overall profits.\n\nProfits = (Unused wallet balance + pending orders value + Current value of portfolio) - Total coins given to you in the contest"}
      />
    </View>
  );
};

export default BottomInfoContest;
